// extracted by mini-css-extract-plugin
module.exports = {"tabGroup":"CustomTab_tabGroup__ToZc8","tabItem":"CustomTab_tabItem__3qmPF","active":"CustomTab_active__3oThJ"};